export default defineNuxtRouteMiddleware((to) => {
  const regionAvailable = to.meta.regionAvailable;

  if (!regionAvailable) {
    return;
  }

  const { region, navigateToLink } = regionAvailable;
  const { clusterCountry } = useClusterCountryConfig();
  const clusterCode = clusterCountry.code;

  const isCorrectRegion = Array.isArray(region)
    ? region.includes(clusterCode)
    : clusterCode === region;

  if (!isCorrectRegion) {
    return navigateTo(clusterRedirectPath(navigateToLink ?? '/'));
  }
});
